<template>
  <div class="ag-floating-filter-input ag-date-range-picker">
    <AppDatePicker
      ref="agDatepicker"
      v-model="currentValue"
      range
      append-to-body
      popup-class="ag-date-range-picker__popup"
      format="DD.MM.YY"
      range-separator="-"
      input-class="ag-input-field-input ag-text-field-input"
      @input="onInput"
      @calendar-change="onCalChange"
    >
      <template #footer>
        <div class="ag-date-range-picker__schnellauswahl">
          <button
            v-for="eintrag in schnellauswahl"
            :key="'cal-short-btn-' + eintrag.text"
            type="button"
            class="ag-date-range-picker__chip"
            @click="bereichWaehlen(eintrag.bereich())"
          >
            {{ eintrag.text }}
          </button>
        </div>
        <AppDatePickerShortcuts :jahr="calendarSelectedYear" @select="bereichWaehlen($event)" />
      </template>
    </AppDatePicker>
  </div>
</template>

<script>
import AppDatePicker from '@/components/common/app-date-picker/app-date-picker.vue';
import AppDatePickerShortcuts from '@/components/common/app-date-picker/app-date-picker-shortcuts.vue';
const moment = require('moment');

export default {
  name: 'DateRangePicker',
  components: { AppDatePicker, AppDatePickerShortcuts },
  data() {
    return {
      params: null,
      currentValue: null,
      schnellauswahl: [
        {
          text: this.$t('COMPONENT.FILTER.DATE.SHORTCUTS.ANFANGJAHR'),
          bereich: () => {
            const start = new Date(new Date().getFullYear(), 0, 1);
            this.calendarSelectedYear = start.getFullYear();
            return [start, start];
          },
        },
        {
          text: this.$t('COMPONENT.FILTER.DATE.SHORTCUTS.HEUTE'),
          bereich: () => {
            const date = new Date();
            this.calendarSelectedYear = date.getFullYear();
            return [date, date];
          },
        },
        {
          text: this.$t('COMPONENT.FILTER.DATE.SHORTCUTS.INMONATE'),
          bereich: () => {
            const start = new Date();
            const newDate = new Date();
            const end = new Date(newDate.setMonth(newDate.getMonth() + 3));
            this.calendarSelectedYear = start.getFullYear();
            return [start, end];
          },
        },
        {
          text: this.$t('COMPONENT.FILTER.DATE.SHORTCUTS.JAHRESENDE'),
          bereich: () => {
            const start = new Date();
            const end = new Date(new Date().getFullYear(), 11, 31);
            this.calendarSelectedYear = start.getFullYear();
            return [start, end];
          },
        },
      ],
      calendarSelectedYear: new Date().getFullYear(),
    };
  },
  mounted() {
    if (this.params?.isReisetermineStartdatum) {
      const start = new Date();
      const end = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
      this.currentValue = [start, end];
      this.onInput();
    }
  },
  methods: {
    onCalChange(date) {
      this.calendarSelectedYear = date.getFullYear();
    },
    onInput() {
      // check if params has function parentFilterInstance
      if (this.params.isChild) {
        this.params.parentFilterInstance(instance => {
          instance.onDateRangeFilterChanged(this.currentValue);
        });
      } else {
        this.params.filterChangedCallback();
      }
    },
    onDateRangeFilterChanged(currentValue) {
      this.currentValue = currentValue;
      this.params.filterChangedCallback();
    },
    bereichWaehlen([von, bis]) {
      this.calendarSelectedYear = von.getFullYear();
      this.$refs.agDatepicker.closePopup();
      this.currentValue = [von, bis];
      this.onInput();
    },
    getModel() {
      if (!this.isFilterActive()) {
        return null;
      }
      const dateFrom = new Date(this.currentValue[0]);
      const dateTo = new Date(this.currentValue[1]);
      if (isNaN(dateFrom.getTime()) && isNaN(dateTo.getTime())) {
        return null;
      } else {
        return {
          dateFrom: moment(dateFrom).format('YYYY-MM-DD 00:00:00'),
          dateTo: moment(dateTo).format('YYYY-MM-DD 00:00:00'),
          filterType: 'date',
          type: 'inRange',
        };
      }
    },
    setModel(model) {
      if (!model) {
        return null;
      }
      const dateFrom = new Date(model.dateFrom);
      const dateTo = new Date(model.dateTo);
      // check dateFrom is invalid date
      if (isNaN(dateFrom.getTime()) && isNaN(dateTo.getTime())) {
        this.currentValue = [null, null];
      } else {
        this.currentValue = [dateFrom, dateTo];
      }
    },
    isFilterActive() {
      return (
        Array.isArray(this.currentValue) &&
        this.currentValue[0] instanceof Date &&
        this.currentValue[1] instanceof Date
      );
    },
    // Wenn der Filter in der Toolbar gesetzt wird
    onParentModelChanged(parentModel, event) {
      // wir sind auf floating filter ebene
      if (parentModel && this.params.isChild) {
        this.currentValue = [new Date(parentModel.dateFrom), new Date(parentModel.dateTo)];
      }
      if (!parentModel) {
        this.currentValue = null;
      }
    },
  },
};
</script>

<style scoped>
.ag-date-range-picker {
  --app-date-picker-width: auto;
}

.ag-date-range-picker :deep(.mx-icon-calendar),
.ag-date-range-picker :deep(.mx-icon-clear) {
  right: 6px;
}

.ag-date-range-picker :deep(.ag-input-field-input) {
  padding-right: 24px;
}
</style>

<style>
.ag-date-range-picker__popup {
  --app-date-picker-calendar-width: 280px;
}

.ag-date-range-picker__popup.app-date-picker-popup .app-date-picker__footer {
  gap: 8px;
  align-items: stretch;
  width: 100%;
}

/* die vier Schnellauswahl-Aktionen im Chip-Muster, gleichmäßig über die Breite verteilt */
.ag-date-range-picker__popup .ag-date-range-picker__schnellauswahl {
  display: flex;
  gap: 8px;
}

/* kein min-width, damit die automatische Mindestgröße das Chip nicht unter seine Textbreite lässt */
.ag-date-range-picker__popup .ag-date-range-picker__chip {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: var(--control-h-sm);
  padding: 0 12px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  color: var(--text-body);
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
}

.ag-date-range-picker__popup .ag-date-range-picker__chip:hover {
  background: var(--surface-hover);
}
</style>
